// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Utils
import { registerDownloadSource } from '../../utils/fileDownloader/javascriptToSwiftFileDownloads';
import { isIpad } from '../../utils/services/browser';
import { getExportErrorText } from './exportErrorUtils';

// Actions
import { exportElement } from './exportPopupActions';
import { closePopup } from '../../components/popupPanel/popupActions';
import { triggerDownload } from '../../element/attachments/attachmentDownloadActions';

// Components
import ExportPopupExportButton from './ExportPopupExportButton';

// Constants
import { TIMES } from '../../../common/utils/timeUtil';
import { PopupIds } from '../../components/popupPanel/popupConstants';
import { DOWNLOADING_STATUSES } from './exportConstants';

// Styles
import './ExportPopupExportButton.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchExportElement: ({ elementId, format, fileType, quality }) =>
        dispatch(exportElement({ elementId, format, fileType, quality })),
    dispatchClosePopup: () => dispatch(closePopup(PopupIds.EXPORT)),
    dispatchTriggerDownload: (args) => dispatch(triggerDownload(args)),
});

const ElementExportPopupButton = (props) => {
    const {
        children,
        elementId,
        disabled,
        fileType,
        format,
        quality,
        dispatchExportElement,
        dispatchClosePopup,
        dispatchTriggerDownload,
    } = props;

    const [status, setStatus] = React.useState(null);
    const [errorText, setErrorText] = React.useState(null);

    const onClick = async () => {
        setStatus(DOWNLOADING_STATUSES.GENERATING);

        try {
            const exportUrl = await dispatchExportElement({
                elementId,
                format,
                fileType,
                quality,
            });

            registerDownloadSource('.ExportUtil .button-content', { x: 0, y: 30 });

            dispatchTriggerDownload({
                url: exportUrl,
                onDownloadEnd: () => {
                    if (isIpad()) {
                        dispatchClosePopup();
                    }
                },
                id: elementId,
            });

            setStatus(DOWNLOADING_STATUSES.DOWNLOADING);
        } catch (err) {
            setStatus(DOWNLOADING_STATUSES.ERROR);
            const text = getExportErrorText(err);
            setErrorText(text);
        }

        setTimeout(() => {
            setStatus(null);
        }, TIMES.SECOND * 2);
    };

    return (
        <ExportPopupExportButton status={status} errorText={errorText} onClickFn={onClick} disabled={disabled}>
            {children}
        </ExportPopupExportButton>
    );
};

ElementExportPopupButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    elementId: PropTypes.string,
    fileType: PropTypes.string,
    format: PropTypes.string,
    quality: PropTypes.string,
    disabled: PropTypes.bool,

    dispatchExportElement: PropTypes.func,
    dispatchClosePopup: PropTypes.func,
    dispatchTriggerDownload: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(ElementExportPopupButton);
